import React from 'react';
import { Row, Col } from 'react-bootstrap5';

import routes from 'app/routes';

export default function Index() {
  return (
    <div className="content">
      <Row>
        <Col lg={{ span: 6, order: 'last' }}>
          <div className="bg-photo bg-managers-billing-no-policy-photo" />
        </Col>

        <Col lg={{ span: 6, order: 'first' }}>
          <div className="py-4 px-sm-4 p-xxl-5">
            <h1 className="mb-5">Billing</h1>

            <p>Create a policy to get started!</p>

            <p>
              Want to get the ball rolling on your Talent Insurance Program?
              Well, it all begins with creating a policy for your company.
              Make sure you have all your ducks in a row and head over to the Policy page to make
              sure everything is squared away &mdash; You can take it from there! So what are you waiting for?
            </p>

            <a
              href={routes.managers.policy.index}
              className="btn btn-primary mt-4"
            >
              Create Policy
            </a>
          </div>
        </Col>
      </Row>
    </div>
  );
}
